import * as React from "react"
const SvgFolderOpen = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18.714v-12q0-.824.587-1.412A1.93 1.93 0 0 1 4 4.714h5.175a1.98 1.98 0 0 1 1.4.575L12 6.714h9q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-9.825l-2-2H4v12l1.975-6.575a1.95 1.95 0 0 1 .738-1.037 2 2 0 0 1 1.187-.388h12.9q1.024 0 1.613.813.587.813.312 1.762l-1.8 6a1.95 1.95 0 0 1-.738 1.038 2 2 0 0 1-1.187.387zm2.1-2H19l1.8-6H7.9z" />
  </svg>
)
export default SvgFolderOpen
